<template>
    <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.value)">
      <span>{{ statusName(params.value) }}</span>
    </vs-chip>
</template>

<script>
    export default {
        name: 'CellRendererStatus',
        data() {
          return {
            ownerStatus: [],
            parentStatus: [],
            statusKey: ''
          }
        },
        computed: {
          chipColor() {
            return (value) => {
              if(value === 2) return "success"
              else if(value === 0) return "danger"
              else if(value === 1) return "warning"
              else "primary"
            }
          },
          statusName() {
            return (value) => this.statusKey && !isNaN(value)
              ? this.statusKey.find(status => status.id === value).description
              : 'Pendiente'
          }
        },
        created() {
          this.ownerStatus = [
           { id: 0, description: "Creado" },
           { id: 1, description: "Aprobado" },
           { id: 2, description: "Activo" },
           { id: 3, description: "Inactivo" },
           { id: 4, description: "No Verificado" }
          ]
          this.statusKey = this.params.data.profileType && this.params.data.profileType == 1 ? this.ownerStatus : this.$store.state.AppData.accountStatus
        },
    }
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}
</style>
